<template>
  <div class="institution-policy-page py-4">
    <b-container style="max-width: 800px;">
      <div v-if="loading" class="text-center py-5">
        <b-spinner label="Loading..." variant="primary" class="mr-2"></b-spinner>
        <span class="font-weight-bold">Loading...</span>
      </div>
      <template v-else>
        <div class="text-center mb-4">
          <img v-if="institutionLogo" :src="institutionLogo" alt="Institution Logo" class="institution-logo mb-2" />
          <h4 class="mb-0 institution-name">{{ institutionName }}</h4>
        </div>
        <!-- <h5 class="mb-3">{{ policyLabel }}</h5> -->
        <div v-if="policyContent" v-html="policyContent"></div>
        <p v-else class="text-muted">This policy is not available.</p>
      </template>
    </b-container>
  </div>
</template>

<script>
const POLICY_LABELS = {
  terms_and_conditions: 'Terms & Conditions',
  privacy_policy: 'Privacy Policy',
  cancellation_refund_policy: 'Cancellation / Refund Policy',
};

export default {
  name: 'InstitutionPolicyView',
  data() {
    return {
      loading: true,
      institutionName: '',
      institutionLogo: '',
      policyContent: '',
    };
  },
  computed: {
    policyLabel() {
      return POLICY_LABELS[this.$route.params.type] || 'Policy';
    },
  },
  async created() {
    await this.getPolicy();
  },
  methods: {
    async getPolicy() {
      this.loading = true;
      const institutionId = this.$route.params.institutionId;
      const type = this.$route.params.type;
      const url = this.$store.getters.getAPIKey.mainAPI + `/institutions/${institutionId}/policies`;
      await this.$axios
        .get(url)
        .then((response) => {
          this.institutionName = response.data.institution_name;
          this.institutionLogo = response.data.institution_logo;
          this.policyContent = response.data.policies[type];
        })
        .catch(() => {});
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.institution-policy-page {
  background-color: #fff;
  min-height: 100vh;
}
.institution-name {
  font-size: 22px !important;
  font-weight: 700;
}
.institution-logo {
  max-height: 80px;
  max-width: 240px;
  object-fit: contain;
}
</style>
